import { render, staticRenderFns } from "./FormLugarMomento.vue?vue&type=template&id=fc1a98d4&scoped=true"
import script from "./FormLugarMomento.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLugarMomento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormLugarMomento.vue?vue&type=style&index=0&id=fc1a98d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1a98d4",
  null
  
)

export default component.exports